import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import SimpleHeader from '../../../../headers/simpleHeader';
import RoleAwareLink from '../../../../../common/RoleAwareLink';
import Input from '../../../../../common/input';
import CustomReportMetrics from '../CustomReportMetrics';
import { REPORT_TYPES } from '../../constants';
import KnowledgeArticleLink from '../../../../../common/KnowledgeArticleLink';
import { CUSTOM_REPORTS_HELP_URL } from '../../../../../common/KnowledgeArticleLink/constants';

const EditCustomReport = ({
  title,
  canDelete,
  handleSubmit,
  handleDelete,
  submitting,
  backLink,
  setReportMetrics,
}) => (
  <form onSubmit={handleSubmit}>
    <SimpleHeader heading={title}>
      <div>
        <RoleAwareLink
          className="c-btn c-btn--white c-btn--medium u-mr"
          to={backLink}
        >Back</RoleAwareLink>
        <button
          display-if={canDelete}
          className="c-btn c-btn--red c-btn--medium u-mr"
          type="button"
          onClick={handleDelete}
        >
          Delete
        </button>
        <button
          type="submit"
          className="c-btn c-btn--medium u-mr"
          disabled={submitting}
        >Save</button>
      </div>
    </SimpleHeader>
    <div className="c-wrapper">
      <div className="c-custom-report-form">
        <h2 className="c-heading u-mb-">
          Report information
          {' '}
          <KnowledgeArticleLink url={CUSTOM_REPORTS_HELP_URL} />
        </h2>
        <p className="u-mb">
          Create a custom report template that you can save and rerun using any of the below metrics
        </p>
        <div className="c-horizontal-divider u-mv" />
        <div className="c-custom-report-form-layout">
          <div className="c-custom-report-form-column">
            <span className="c-label-new">Name</span>
            <Input className="c-input c-input--border c-input--v3 u-mt-" name="name" type="text" placeholder="Name" />
          </div>
          <div className="c-custom-report-form-column">
            <span className="c-label-new">Type</span>
            <Field component="select" name="type" className="c-select u-mt-">
              <option value={REPORT_TYPES.BARBER}>Barber Report</option>
              <option value={REPORT_TYPES.LOCATION}>Location Report</option>
            </Field>
          </div>
        </div>
        <CustomReportMetrics
          onReportMetricsChange={setReportMetrics}
        />
      </div>
    </div>
  </form>
);

EditCustomReport.propTypes = {
  backLink: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  canDelete: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  setReportMetrics: PropTypes.func.isRequired,
};

EditCustomReport.defaultProps = {
  handleSubmit: () => null,
  handleDelete: () => null,
  canDelete: false,
  reportMetrics: [],
};

export default EditCustomReport;
